import { createSelector } from "@reduxjs/toolkit";
import { get, find } from 'lodash';

const competitionDetail = (state) => state.competitionDetail;
const genreLookup = (state) => state.genreLookup;
const entryState = state => state.entryState;

export const competitionInstitutionRequired = createSelector([competitionDetail], (detail) => {
  return parseInt(get(detail, 'institution_required', 0), 10);
})

export const genreInstitutionRequired = createSelector([genreLookup, entryState], (lookup, entryState) => {
  // get the genreId from the selected category (entryState)
  // find the genreId in the genreLookup
  // return the value for 'institution_required'

  // genreId
  // institution_required
  
  const id = parseInt(get(entryState, 'genre_id', 0), 10);

  const genreInfo = find(lookup, e => e.genreId === id);

  if (genreInfo) {
    return parseInt(get(genreInfo, 'institution_required', 0), 10);
  }

  return 0;
})